<template>
  <div>
    <v-container class="page" fluid>
    <v-row >
      <v-col no-gutters>
        <div style="margin-top: 5cm;" v-if="this.loading">
          <Loading/>
        </div>
        <v-container v-if="!this.loading" fluid :style="!$vuetify.breakpoint.smAndDown ? 'margin-left: 2cm; margin-top: 2cm;' : 'margin-left: auto; margin-top: 2cm;'">
          <h1 v-if="this.step == 1">Sign up</h1>
          <h2 v-if="this.step == 2">Personal info</h2>
          <h2 v-if="this.step == 3">Payment</h2>
          <h2 v-if="this.step == 4">T's & C's</h2>
          <h2 v-if="this.step == 5">Profile successfully created. <br/> <br/> Please log in to book.</h2>
          <h2></h2>
          <br/> <br/>
          <v-row justify="center">
            <v-col md="7">
              <div v-if="step === 1" :style="(step === 1) ? 'text-align: center;' : 'display: none;'">
                <validation-observer ref="observer-1">
                  <validation-provider
                      rules="email|required"
                      v-slot="{ errors }">
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-email"
                      autofocus
                      autocomplete="off"
                      type="email"
                      name="emailAddress"
                      id="email"
                      :class="(errors[0]) ? 'input-error' : ''"
                      placeholder="  Email Address"
                      v-model="form.emailAddress"
                    ></v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                  <validation-provider
                      name="password"
                      rules="required|min:6"
                      v-slot="{ errors }">
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-lock"
                      autocomplete="off"
                      name="password"
                      id="password"
                      placeholder="  Password"
                      v-model="form.password"
                      :class="(errors[0]) ? 'input-error' : ''"
                      :type="show ? 'text' : 'password'"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                    >
                    </v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                  <validation-provider
                      rules="required|confirmedPassword:@password"
                      v-slot="{ errors }">
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-lock"
                      autocomplete="off"
                      name="confirm-password"
                      id="confirm-password"
                      placeholder="  Confirm password"
                      v-model="form.confirmPassword"
                      :class="(errors[0]) ? 'input-error' : ''"
                      :type="show ? 'text' : 'password'"
                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="show = !show"
                    >
                    </v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                </validation-observer>
              </div>
              <div v-if="step === 2" :style="(step === 2) ? 'text-align: center;' : 'display: none;'">
                <validation-observer ref="observer-2">
                  <v-row>
                    <v-col>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }">
                        <v-text-field
                            filled
                            autocomplete="off"
                            type="text"
                            name="fname"
                            id="firstname"
                            v-model="form.fname"
                            placeholder="First name"
                            :class="(errors[0]) ? 'input-error' : ''"
                        ></v-text-field>
                        <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider
                        rules="required"
                        v-slot="{ errors }">
                        <v-text-field
                            filled
                            type="text"
                            name="lname"
                            id="lastname"
                            v-model="form.lname"
                            placeholder="Last name"
                            :class="(errors[0]) ? 'input-error' : ''"
                        ></v-text-field>
                        <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <validation-provider
                      rules="required|phone"
                      v-slot="{ errors }">
                    <v-text-field
                      filled
                      prepend-inner-icon="mdi-phone"
                      autocomplete="off"
                      type="text"
                      name="mobile"
                      id="phone"
                      :class="(errors[0]) ? 'input-error' : ''"
                      placeholder="  Mobile Number eg: 0671234567"
                      v-model="form.mobile"
                    >
                    </v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ errors }">
                    <v-text-field
                        filled
                        prepend-inner-icon="mdi-office-building"
                        type="text"
                        name="company_reg_no"
                        id="companyname"
                        v-model="form.companyname"
                        placeholder="  Company name (if applicable)"
                        :class="(errors[0]) ? 'input-error' : ''"
                    ></v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                  <validation-provider
                      v-slot="{ errors }"
                      rules="vatLength">
                    <v-text-field
                        filled
                        prepend-inner-icon="mdi-note-text-outline"
                        type="text"
                        name="vat_no"
                        id="vat"
                        v-model="form.vat_no"
                        placeholder="  VAT no. (if applicable)"
                        :class="(errors[0]) ? 'input-error' : ''"
                    ></v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>
                </validation-observer>
              </div>
              <div v-if="step === 3" :style="(step === 3) ? '' : 'display: none;'">
                  <v-row justify="center">
                    <v-col align="center">
                      <div style="display: block; align-self: center;">
                        <a href="https://www.peachpayments.com/" target="_blank">
                        <v-img
                        contain
                        src="@/assets/PeachLogo.png"
                        alt="Logo"
                        max-height="120"
                        max-width="170"
                        /> </a>
                        <br/>
                        <a href="https://www.peachpayments.com/" target="_blank">
                        <v-img
                        contain
                        src="@/assets/visa.png"
                        alt="Logo"
                        max-height="200"
                        max-width="250"
                        /> </a>
                        </div>
                    </v-col>
                  </v-row>
                  <br/><br/><br/>
                  <v-row no-gutters>
                    <v-col align="right">
                      <v-btn
                        :dark="this.eft ? true : false"
                        style="border-radius: 30px;"
                        width="100"
                        height="50"

                        large
                        @click="checkEft()"
                        >EFT</v-btn>
                    </v-col>
                    <v-col align="left">
                      <v-btn
                        :dark="this.card ? true : false"
                        style="border-radius: 30px;"
                        width="100"
                        height="50"

                        large
                        @click="checkCard()"
                        > Card </v-btn>
                    </v-col>
                  </v-row>
                  <br/> <br/>
                    <v-label v-if="this.eft"> Pay: Dash Waste [WRAPP Technologies (Pty) Ltd] <br/><br/>
                    Bank: Nedbank <br/><br/>
                    Account number: 1131205936 <br/> <br/>
                    Branch code: 198765 <br/><br/>
                    Email confirmation to sales@dashwaste.co.za</v-label>
                    <br/>
                <validation-observer ref="observer-3" v-if="this.card">
                  <h3>Credit or Debit card </h3> <br/>
                  <p> <strong>Your card will only be charged once service is completed.</strong></p>
                  <br/><br/>
                  <validation-provider
                      rules="card"
                      v-slot="{ errors }">
                    <v-text-field
                        filled
                        prepend-inner-icon="mdi-credit-card"
                        type="text"
                        name="cardno"
                        id="cardno"
                        v-model="form.cardno"
                        placeholder="  Card number"
                        :class="(errors[0]) ? 'input-error' : ''"
                    ></v-text-field>
                    <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                  </validation-provider>

                  <v-row>
                    <v-col>
                      <validation-provider
                        rules="expiry"
                        v-slot="{ errors }">
                        <v-text-field
                            filled
                            type="text"
                            name="expiry"
                            id="expiry"
                            v-model="form.month"
                            placeholder="  Expiry (mm/yy)"
                            :class="(errors[0]) ? 'input-error' : ''"
                            class="expiry"
                        ></v-text-field>
                        <span class="input-error-text">{{ errors[0] }}</span>
                      </validation-provider>
                    </v-col>
                    <v-col>
                      <validation-provider
                        rules="length"
                        v-slot="{ errors }">
                        <v-text-field
                            filled
                            type="text"
                            name="cvv"
                            id="cvv"
                            v-model="form.cvv"
                            placeholder="  CVV"
                            :class="(errors[0]) ? 'input-error' : ''"
                            class="expiry"
                        ></v-text-field>
                        <span style="color: red;" class="input-error-text">{{ errors[0] }}</span>
                      </validation-provider>
                    </v-col>
                  </v-row>
                </validation-observer>
                <br/> <br/>
                <span v-for="(error, idx) of errors" :key="idx" class="error-block">{{ error }}</span>
                <button v-if="this.card || this.eft" class="tc" @click="step++"> Here are our terms and conditions </button>
                <v-checkbox
                v-if="this.card || this.eft"
                v-model="check"
                label="I have read and agreed to the terms and conditions"
                color="red"
                >
                </v-checkbox>
              </div>
              <div class="tc" v-if="step === 4 " :style="(step === 4) ? '' : 'display: none;'">
                <button  @click="step--"> Accept Terms and Conditions </button>
                <tc/>
                <button  @click="step--"> Accept Terms and Conditions </button>
              </div>
              <div class="tc" v-if="step === 5 " :style="(step === 5) ? 'text-align: center;' : 'display: none;'">
                <img src="@/assets/tick.gif" height="100" width="100"/>
                <br/><br/>
              </div>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col md="7" align="center">
              <v-btn
              v-if="this.step == 1"
              block
              style="background-color: #4BB27C; color: white; margin-top: -0.5cm; border-radius: 30px;"
              height="60"
              @click="signUp()"> Next Step </v-btn>

              <v-btn
              v-if="this.step == 2"
              block
              style="background-color: #4BB27C; color: white; margin-top: -0.5cm; border-radius: 30px;"
              height="60"
              @click="captureAdditionalInformation()"> Next Step </v-btn>

              <v-btn
              v-if="this.step == 3 && check"
              block
              style="background-color: #4BB27C; color: white; margin-top: -0.5cm; border-radius: 30px;"
              height="60"
              @click="captureCardInformation()"> Sign Up </v-btn>

              <v-btn
              :disabled="disabled"
              v-if="this.step == 5"
              block
              style="background-color: #4BB27C; color: white; margin-top: -0.5cm; border-radius: 30px;"
              height="60"
              @click="redirectPage()"> Log In </v-btn>
              <br/> <br/> <br/> <br/> <br/>
              <span v-if="this.step == 1">Already have an account? <router-link to="/login" style="color: #4BB27C; text-decoration: none;"> Log in </router-link> </span>
            </v-col>
          </v-row>
        </v-container>
      </v-col>
      <v-col v-if="!$vuetify.breakpoint.smAndDown" no-gutters cols="6">
        <v-img src="@/assets/driver.png" height="100vh" width="100%" style="margin-top: -1cm;"></v-img>
      </v-col>
    </v-row>
  </v-container>
  </div>
</template>

<script>
import Loading from "@/components/Loading";
import tc from "@/views/tc"
import { getAuth, createUserWithEmailAndPassword } from "firebase/auth";
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate';
import { email, required } from 'vee-validate/dist/rules';
import { getFunctions, httpsCallable } from "firebase/functions";

const functions = getFunctions();
const phoneRegex = /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3}?)[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/
const expiryRegex = /^[0-9]{2}\/[0-9]{2}$/
const auth = getAuth();

  extend('required', {
    ...required,
    message: 'This field is required.'
  })

  extend('email', {
    ...email,
    message: 'Invalid email'
  })

  extend('length', {
    params: [],
    validate(value) {
      if(value.length == 3)
      return true;
    },
    message: 'CVV must be three numbers'
  })

  extend('vatLength', {
    params: [],
    validate(value) {
      if(value.length == 10)
      return /^[0-9]+$/.test(value);
    },
    message: 'Vat number must be 10 digits only'
  })

  extend('numbers', {
    validate(value) {
      return /^[0-9]+$/.test(value)
    }
  })

  extend('expiry', {
    params: [],
    validate(value) {
      let valid = true;
      valid = expiryRegex.test(value)
      let parts = value.split("/")
      let expiry = new Date();
      expiry.setFullYear('20'+parts[1], parts[0])
      if (expiry > new Date()) {
        return valid
      } else {
        return false;
      }
    },
    message: "Invalid expiry"
  })

  extend('phone', {
    params: [],
    validate(value) {
      return phoneRegex.test(value)
    },
    message: "Invalid phone number"
  })

  extend('card', {
    params: [],
    validate(value) {
      value = value.replace(/[^0-9]/g, "")
      const condTransform = (predicate, value, fn) => {
        if (predicate) {
          return fn(value);
        } else {
          return value;
        }
      };
      const doubleEveryOther = (current, idx) =>
        condTransform(idx % 2 === 0, current, x => x * 2)
      const reduceMultiDigitVals = current =>
        condTransform(current > 9, current, x => x - 9)
      let digits = value.split("").map(Number)
      let luhn_digit = digits[digits.length - 1]
      let total = digits
        .slice(0, -1)
        .reverse()
        .map(doubleEveryOther)
        .map(reduceMultiDigitVals)
        .reduce((curr, acc) => curr + acc, luhn_digit)
      return total % 10 === 0
    },
    message: "Invalid card number"
  })

  extend('min', {
    validate(value, { min }) {
      return value.length >= min
    },
    params: ['min'],
    message: 'Must consist of more than {min} characters'
  })

  extend('confirmedPassword', {
    params: ['target'],
    validate(value, { target }) {
      return value == target
    },
    message: 'Passwords do not match'
  })

  export default {
    name: 'SignUp',
    components: {
      Loading,
      tc,
      ValidationProvider,
      ValidationObserver
    },
    data() {
      return {
        step: 1,
        user: {},
        form: {
          emailAddress: '',
          mobile: '',
          password: '',
          confirmPassword: '',
          fname: '',
          lname: '',
          companyname: '',
          vat_no: ''
        },
        errors: [],
        loading: false,
        check: false,
        show: false,
        eft: false,
        card: true,
        disabled: false
      }
    },
    computed: {
      redirectUrl(){
        return this.$store.getters['auth/getRedirectUrl'];
      }
    },
    methods: {
      checkEft(){
        this.eft = true;
        this.card = false;
      },
      checkCard(){
        this.eft = false;
        this.card = true;
      },
      signUp: async function() {
        if (await this.$refs['observer-1'].validate()) {
          this.loading = true;
          createUserWithEmailAndPassword(auth, this.form.emailAddress, this.form.password)
            .then((res) => {
              this.user = res.user;
              this.step++;
              this.loading = false;
            })
            .catch((error) => {
              // Handle Errors here.
              this.loading = false;
              console.error(error);
              alert('Email already in use. Please use a different email address');
            });
        }
        else{
          alert('Please make sure to fill in details as required');
          this.loading = false;
        }
      },
      captureAdditionalInformation: async function() {
        let company = this.form.companyname && this.form.companyname != '' ? this.form.companyname : this.form.fname + " " + this.form.lname;
        if (await this.$refs['observer-2'].validate()) {
          this.loading = true;
          if(company.trim().toLowerCase() == 'private' || 
            company.trim().toLowerCase()  == 'prvt' || 
            company.trim().toLowerCase()  == 'privaat' ||
            company.trim().toLowerCase()  == 'self')
          {
            alert('Invalid company name. Please leave empty if not applicable');
            this.loading = false;
            return;
          }
          //check if company name already in use.
          const checkCompanyName = httpsCallable(functions, 'checkCompanyName');
          await checkCompanyName(company.trim())
          .then(async (snapshot) => {
            if(snapshot.data.isCompanyName == true){
              alert('Company Name already in use. Please leave empty and proceed.');
              return;
            }
            else{
              let Customer = {
              id: this.user.uid,
              mobile: this.form.mobile.trim(),
              firstName: this.form.fname.trim(),
              lastName: this.form.lname.trim(),
              companyName: company.trim(),
              vatNo: this.form.vat_no.trim(),
              emailAddress: this.form.emailAddress.trim(),
              scope: 'client'
            } 
            await this.$store.dispatch('auth/registerUser', Customer);
            this.step++;
            this.loading = false;
            }
          })
          .catch((err) => {
            alert('Something went wrong. Please contact 072 245 9777 for assistance.');
            console.log(err);
          })
        }
        else{
          alert('Please make sure to fill in details as required');
        }
      },
      captureCardInformation: async function() {
        if(this.card){
          if (await this.$refs['observer-3'].validate()) {
            this.loading = true;
            //clear user login session
            await auth.signOut()
            .then(() => {
              sessionStorage.clear();
              this.$store.commit('auth/logout');
            });
            this.form.id = this.user.uid;
            await this.$store.dispatch('auth/registerUserCard', this.form);
            this.cvv = '';
            this.step = 5;
            this.loading = false;
          }
          else{
            alert('Please make sure to fill in details as required');
          }
        }
        if (this.eft){
          this.loading = true;
          //clear user login session
          auth.signOut()
          .then(() =>{
            sessionStorage.clear();
            this.$store.commit('auth/logout');
          });
          this.cvv = '';
          this.step = 5;
          this.loading = false;
        }
      },
      async redirectPage() {
        this.disabled = true;
        this.loading = true;
        this.form.id = this.user.uid;
        await this.$store.dispatch('auth/completeRegistration', this.form);
        //send user email after successful registration
        this.$store.dispatch('userMail', {
          email: this.form.emailAddress,
          username: this.form.fname + ' ' + this.form.lname
        });
        if(this.eft){
          setTimeout(async() => {
            this.loading = false;
            window.location.href = `/login?emailAddress=${this.form.emailAddress}&password=${btoa(this.form.password)}`;
          },  
          6000); 
        }
        if (this.card && this.redirectUrl != '') {
          alert('Transaction Pending... You will be redirected to confirm your card details');
          window.location.href = this.redirectUrl;
        }
        else{
          setTimeout(async() => {
            this.loading = false;
            window.location.href = `/login?emailAddress=${this.form.emailAddress}&password=${btoa(this.form.password)}`;
          },  
          6000);
        } 
      }

    },
    mounted(){
    }
  }
</script>

<style lang="scss" scoped src="@/scss/auth.scss"></style>